module.exports = __webpack_public_path__ + "media/images/marble-background-8961720e8b8dd1fd168e7697f892593d.jpg";